/**
 *
 * mapv上的layer管理
 *
 */

export default {
  list: [], // 保存图层的队列
  add (item) {
    // 添加一个新图层，并返回索引
    return this.list.push(item) - 1
  },
  destroy (index) {
    // 按索引销毁图层
    this.list[index].destroy()
  },
  destroyAll () {
    // 销毁所有图层
    this.list.forEach(item => {
      item.destroy()
    })
    this.list.length = 0 // 队列长度置0
  }
}
